import React from "react";
import { Colors, Typography, UserForResolver } from "@factorearth/component-library";
import styles from "./PhotoLogRow.module.scss";
import { UpdateContext } from "utils/UpdateContext";
import FieldAction from "components/FieldAction/FieldAction";
import { FieldInstance } from "db/definitions";

interface PhotoLogRowProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	colorPalette: Colors;
	rowData: FieldInstance[];
	checkedRows: string[];
	setCheckedRows: React.Dispatch<React.SetStateAction<string[]>>;
	rowId: string;
	online: boolean;
	setupDrawer: (location: Location | "") => void;
	userDoc: UserForResolver;
}

export const PhotoLogRow = (props: PhotoLogRowProps) => {
	const { colorPalette, rowData, checkedRows, setCheckedRows, rowId, setupDrawer, online, userDoc } = props;

	const handleCheckOrUncheck = (id: string) => {
		setCheckedRows((prev) => (prev.includes(id) ? prev.filter((row) => row !== id) : [...prev, id]));
	};

	function createFieldHtml(tableField: FieldInstance, rowData?: FieldInstance[]) {
		const isLink = !!(
			tableField.altInstanceId &&
			(tableField.fieldTemplate?.action?.includes("LINK") || tableField.fieldTemplate?.action?.includes("LINK_TO"))
		);
		const altId = tableField.altInstanceId;
		const altFieldInstance: FieldInstance | null = isLink
			? {
					...tableField,
					id: altId!,
					value: tableField.altInstance?.value ?? tableField.value ?? "",
					authors: tableField.altInstance?.authors ?? tableField.authors ?? [],
					altInstanceId: altId,
				}
			: null;

		return (
			<UpdateContext.Consumer key={`IMAGEROLLFIELD-${tableField.id}`}>
				{({ updateObj, setupChanged }) => (
					<div className={styles.inputsRow}>
						<FieldAction
							setupDrawer={setupDrawer}
							updateObj={isLink ? updateObj[altId!] : updateObj[tableField.id]}
							fieldInstance={isLink ? altFieldInstance : tableField}
							setupChanged={setupChanged}
							fieldTemplate={tableField.fieldTemplate}
							online={online}
							userDoc={userDoc}
							key={tableField.id + "-row"}
							fromTable={true}
							rowsData={rowData}
						/>
					</div>
				)}
			</UpdateContext.Consumer>
		);
	}

	return (
		<tbody data-test="photo-log-row">
			<tr
				className={styles.tableRow}
				style={{
					background: colorPalette.background.primary,
					borderBottom: `${colorPalette.border.primary} 0.5px solid`,
				}}>
				<td className={styles.tableCell} style={{ borderBottom: `${colorPalette.border.primary} 0.5px solid` }}>
					<input
						className={styles.styledCheckbox}
						type="checkbox"
						id={rowId}
						data-test="photo-log-select-row-checkbox"
						checked={checkedRows.includes(rowId)}
						onChange={() => handleCheckOrUncheck(rowId)}
					/>
				</td>
				{Array.isArray(rowData) &&
					rowData.map((fieldInstance, idx) => {
						const hasRowData = fieldInstance?.fieldTemplate?.inputType === "image" ? rowData : undefined;
						return (
							<td className={styles.tableCell} style={{ borderBottom: `${colorPalette.border.primary} 0.5px solid` }} key={idx}>
								{createFieldHtml(fieldInstance, hasRowData)}
							</td>
						);
					})}
			</tr>
		</tbody>
	);
};
